import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => (
  <main>
    <Contact />
  </main>
);

export default ContactPage;



